import React from "react";
import met4LUL from "../met4LUL.png";
var newDate = new Date();

class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = { newDate: new Date(), newStamp: newDate.getTime() };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      newDate: new Date(),
      newStamp: new Date().getTime()
    });
  }

  render() {
    var startDateTime = new Date(1568383200000); // YYYY (M-1) D H m s ms (start time and date from DB)
    var startStamp = startDateTime.getTime();

    var diff = Math.round((this.state.newStamp - startStamp) / 1000);
    var d = Math.floor(
      diff / (24 * 60 * 60)
    ); /* though I hope she won't be working for consecutive days :) */
    diff = diff - d * 24 * 60 * 60;
    var h = Math.floor(diff / (60 * 60));
    diff = diff - h * 60 * 60;
    var m = Math.floor(diff / 60);
    diff = diff - m * 60;
    var s = diff;

    if (s < 10) {
      s = pad(s, 2);
    }
    if (m < 10) {
      m = pad(m, 2);
    }

    function pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    }

    if (this.state.newStamp < 1568789100000) {
      return (
        <div>
          Race Started{` `}
          {d}:{h}:{m}:{s} ago
        </div>
      );
    } else {
      return (
        <div>
          CONGRATULATIONS TO METAPHOR! Victory took 5:16:45:00.
          <img src={met4LUL} alt="met4LUL" />
        </div>
      );
    }
  }
}

//ReactDOM.render(<Clock />, document.getElementById("root"));
export default Clock;
